<template>
  <div>
    <router-view v-if="authPage" />
    <DashboardLayout v-else>
      <router-view />
    </DashboardLayout>
    <ToastContainer />
  </div>
</template>

<style lang="scss">
</style>

<script>
import DashboardLayout from "./components/DashboardLayout.vue";
import ToastContainer from "./components/ToastContainer.vue";
export default {
  components: { DashboardLayout, ToastContainer },
  data() {
    return {};
  },
  computed: {
    authPage() {
      return this.$route.fullPath.includes("/auth/");
    },
  },
  // mounted() {
  //   console.log(this.authPage);
  // },
  // watch: {
  //   authPage() {
  //     console.log(this.authPage);
  //   },
  // },
};
</script>
<style>
* {
  box-sizing: border-box;
}
</style>